import { ActivatedRouteSnapshot, ResolveFn, RouterStateSnapshot } from "@angular/router";
import { User } from "../models/user";
import { inject } from "@angular/core";
import { UserService } from "../services/user/user.service";

export const userDataResolver: ResolveFn<User> = (route: ActivatedRouteSnapshot, state: RouterStateSnapshot) => {
	return inject(UserService).getMe();
}
